/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/base-action-links.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const HeroBannerFragment = gql`
  ${BaseActionLinksFragment}
  ${BaseHeroBannerFragment}
  ${BaseImageFragment}
  ${BaseRichTextBlockFragment}
  ${BaseVideoFragment}

  fragment HeroBannerFragment on HeroBanner {
    ...BaseHeroBannerFragment

    backgroundMedia {
      ... on Image {
        ...BaseImageFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
    body {
      ...BaseRichTextBlockFragment
    }
    cta {
      ...BaseActionLinksFragment
    }
    rightCta {
      ...BaseActionLinksFragment
    }
  }
`;
